import React from 'react';

const NappLogo = () => {
  return (
    <div className="secondary-color" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', color: 'white' }}>
      <img alt="skog" style={{ maxHeight: 80, width: 'auto' }} src="/fishing-pole.png" /> <h1 className="logo">napp</h1>
    </div>
  )
}
export default NappLogo;